(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (e) => {
    const join = document.querySelector('.header-join');
    if (!join) return;

    const toggle = e.target.closest('[data-join-toggle]');
    const insideForm = e.target.closest('[data-join-form]');

    if (toggle) {
      join.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', join.classList.contains('is-open'));
      return;
    }

    if (!insideForm && !e.target.closest('.header-join')) {
      join.classList.remove('is-open');
    }
  });

  document.addEventListener('submit', async (e) => {
  const form = e.target;

  if (!form.matches('form[action="/contact"]')) return;

  e.preventDefault();

  // Prevent double submit
  if (form.classList.contains('smart-form-loading')) return;

  form.classList.add('smart-form-loading');

  // Remove old messages
  form.querySelectorAll('.smart-form-error').forEach(el => el.remove());

  const successEl =
    form.querySelector('.smart-form-success') ||
    (() => {
      const p = document.createElement('p');
      p.className = 'smart-form-success';
      p.hidden = true;
      form.appendChild(p);
      return p;
    })();

  try {
    const res = await fetch('/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: {
        'Accept': 'application/json'
      }
    });

    if (!res.ok) throw new Error('Submission failed');

    // SUCCESS
    successEl.textContent = 'Thanks! Please check your email 📩';
    successEl.hidden = false;

    // Optional: reset email input
    const emailInput = form.querySelector('input[type="email"]');
    if (emailInput) emailInput.value = '';

    // Optional: auto-close header form
    const joinWrapper = form.closest('.header-join');
    if (joinWrapper) {
      setTimeout(() => joinWrapper.classList.remove('is-open'), 1200);
    }

  } catch (err) {
    const error = document.createElement('p');
    error.className = 'smart-form-error';
    error.textContent = 'Something went wrong. Please try again.';
    form.appendChild(error);
  } finally {
    form.classList.remove('smart-form-loading');
  }
});


  } catch(e) { console.error(e); }
})();
})();
